// extracted by mini-css-extract-plugin
module.exports = {"toggle":"toggle_toggle__4RZp7","slider":"toggle_slider__3Ek24","disabled":"toggle_disabled__6XJDm","inverse":"toggle_inverse__ZXk55"};